export default state => state.customer.personal_details.phone;
